import { render, staticRenderFns } from "./RegInputSelect.vue?vue&type=template&id=5b14e0c6"
import script from "./RegInputSelect.vue?vue&type=script&lang=js"
export * from "./RegInputSelect.vue?vue&type=script&lang=js"
import style0 from "./RegInputSelect.vue?vue&type=style&index=0&id=5b14e0c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports